import ResponseStatus from '../constants/ResponseStatus';
import { fetchHomeData } from '../veevaIdApi';
import { showErrorNotificationFromResponse } from './errorUtils';

/**
 * @typedef ApplicationsResponse
 * @prop {string} name
 * @prop {string} companyName
 * @prop {string} companyIdentifier
 * @prop {string} description
 * @prop {string} [lastLogin] ISO datetime
 * @prop {string} lastLoginFormatted human-readable date, formatted by locale
 * @prop {string} appRedirectUrl
 */

/**
 * Wrapper that fetches home (now named Systems) data and modifies the result
 * @param {string} language
 * @returns {ApplicationsResponse[]}
 */
const getHomeData = async (language) => {
    const response = await fetchHomeData();
    if (response.responseStatus !== ResponseStatus.SUCCESS) {
        const i18nOptions = { language };
        showErrorNotificationFromResponse(response, i18nOptions);
        return [];
    }

    if (!response?.data) {
        return [];
    }

    const transformedTenantList = response?.data?.map((app) => ({
        ...app,
        lastLogin: app.lastLogin && new Date(app.lastLogin),
    }));

    return transformedTenantList;
};

export default getHomeData;
